import type { ExLibSortKey, ExViewState, WkViewState } from '../types/library';

const EX_VIEW_STATE_KEY = 'trainer_library_exercises_view_state_v1';
const WK_VIEW_STATE_KEY = 'trainer_library_workouts_view_state_v1';

export function readExViewState(): Partial<ExViewState> {
  if (typeof window === 'undefined') return {};
  try {
    const raw = window.sessionStorage.getItem(EX_VIEW_STATE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    if (parsed && typeof parsed === 'object') return parsed as Partial<ExViewState>;
    return {};
  } catch {
    return {};
  }
}

export function writeExViewState(state: ExViewState): void {
  if (typeof window === 'undefined') return;
  try {
    window.sessionStorage.setItem(EX_VIEW_STATE_KEY, JSON.stringify(state));
  } catch {
    /* sessionStorage may be unavailable — silently no-op. */
  }
}

export function readWkViewState(): Partial<WkViewState> {
  if (typeof window === 'undefined') return {};
  try {
    const raw = window.sessionStorage.getItem(WK_VIEW_STATE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    if (parsed && typeof parsed === 'object') return parsed as Partial<WkViewState>;
    return {};
  } catch {
    return {};
  }
}

export function writeWkViewState(state: WkViewState): void {
  if (typeof window === 'undefined') return;
  try {
    window.sessionStorage.setItem(WK_VIEW_STATE_KEY, JSON.stringify(state));
  } catch {
    /* sessionStorage unavailable — silently no-op. */
  }
}

export { EX_VIEW_STATE_KEY, WK_VIEW_STATE_KEY };
export type { ExLibSortKey };
